import { RawDataState } from './model'
import { AppState } from '../../types';
import { environmentSelectorSelectors } from '../../common/environment/selectors'
import { resourceSelectorSelectors } from '../../common/resource/selectors'
import { resourceTargetSelectors } from '../../common/resource/target/selectors'

const getAll = (state: AppState): RawDataState => state.monitoring.rawData

export const getIsLoading = (state: AppState) => getAll(state).isLoading
export const getSelectedDate = (state: AppState) => getAll(state).selectedDate
export const getLogFiles = (state: AppState) => getAll(state).logFiles
export const getAllTargets = (state: AppState) => getAll(state).allTargets
export const getEnvironmentSelector = environmentSelectorSelectors<AppState>((state: AppState) => getAll(state).environmentSelector)
export const getResourceSelector = resourceSelectorSelectors<AppState>((state: AppState) => getAll(state).resourceSelector)
export const getTargetsSelector = resourceTargetSelectors<AppState>((state: AppState) => getAll(state).targetsSelector)
